/**
 * Sincroniza UI de ligação ativa entre a janela principal e /popup-call
 * (o Softphone Twilio vive numa janela; DTMF/hangup são encaminhados via BroadcastChannel).
 */

const CHANNEL_NAME = "xpro-voice-call-session";

let sharedChannel = null;

function ensureChannel() {
  if (typeof BroadcastChannel === "undefined") return null;
  if (sharedChannel) return sharedChannel;
  try {
    sharedChannel = new BroadcastChannel(CHANNEL_NAME);
  } catch (_) {
    sharedChannel = null;
  }
  return sharedChannel;
}

export function isCallPopupShell() {
  if (typeof window === "undefined") return false;
  return String(window.location?.pathname || "").startsWith("/popup-call");
}

export function serializeOutgoingCall(outgoingCall) {
  if (!outgoingCall) return null;
  const start = outgoingCall.startTime;
  const params = outgoingCall.callInstance?.parameters || {};
  return {
    toNumber: outgoingCall.toNumber || null,
    fromNumber: outgoingCall.fromNumber || null,
    startTime: start ? new Date(start).toISOString() : null,
    channelId: outgoingCall.channelId || null,
    leadId: outgoingCall.leadId || null,
    mode: outgoingCall.mode || null,
    bridgeMode: outgoingCall.bridgeMode || null,
    callSid: outgoingCall.callSid || null,
    parentCallSid:
      outgoingCall.parentCallSid ||
      String(params.ParentCallSid || "").trim() ||
      null,
    canDtmf: Boolean(outgoingCall.callInstance) || outgoingCall.mode === "mock",
    canHangupRemote: Boolean(outgoingCall.canHangupRemote) || outgoingCall.mode === "twilio_pstn",
    uiInPopup: Boolean(outgoingCall.uiInPopup),
  };
}

export function publishActiveCallSession(session) {
  const ch = ensureChannel();
  if (!ch) return;
  try {
    ch.postMessage({ type: "session", session, at: Date.now() });
  } catch (err) {
    console.warn("[callSessionBridge] publish session:", err?.message || err);
  }
}

export function publishCallCleared() {
  const ch = ensureChannel();
  if (!ch) return;
  try {
    ch.postMessage({ type: "cleared", at: Date.now() });
  } catch (err) {
    console.warn("[callSessionBridge] publish cleared:", err?.message || err);
  }
}

/** Aba com Device Twilio avisa as outras janelas (Chrome / app / escritório virtual). */
export function publishIncomingRing(payload = {}) {
  const ch = ensureChannel();
  if (!ch) return;
  try {
    ch.postMessage({ type: "incoming_ring", payload, at: Date.now() });
  } catch (err) {
    console.warn("[callSessionBridge] publish incoming:", err?.message || err);
  }
}

export function publishIncomingCleared(payload = {}) {
  const ch = ensureChannel();
  if (!ch) return;
  try {
    ch.postMessage({ type: "incoming_cleared", payload, at: Date.now() });
  } catch (err) {
    console.warn("[callSessionBridge] publish incoming cleared:", err?.message || err);
  }
}

export function publishCallAction(action, payload = {}) {
  const ch = ensureChannel();
  if (!ch) return;
  try {
    ch.postMessage({ type: "action", action, payload, at: Date.now() });
  } catch (err) {
    console.warn("[callSessionBridge] publish action:", err?.message || err);
  }
}

export function requestCallSessionSync() {
  publishCallAction("request_sync");
}

/**
 * @param {(msg: any) => void} handler
 * @returns {() => void}
 */
export function subscribeCallSessionBridge(handler) {
  const ch = ensureChannel();
  if (!ch) return () => {};

  const onMessage = (ev) => {
    try {
      handler(ev?.data);
    } catch (err) {
      console.warn("[callSessionBridge] handler:", err?.message || err);
    }
  };
  ch.addEventListener("message", onMessage);
  return () => {
    try {
      ch.removeEventListener("message", onMessage);
    } catch (_) {
      /* ignore */
    }
  };
}
